import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import { PressureSystemType } from '@authority-labs/api-interfaces';
import { CertificateBase1001Component } from '../../base-1001-certificate';

@Component({
  selector:
    'authority-labs-certificate-pressure-system-in-stairwells-compatibility-check',
  templateUrl:
    './certificate-pressure-system-in-stairwells-compatibility-check.component.html',
  styleUrls: [
    './certificate-pressure-system-in-stairwells-compatibility-check.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom
})
export class CertificatePressureSystemInStairwellsCompatibilityCheckComponent
  extends CertificateBase1001Component
  implements OnInit
{
  systemDescription = `בדיקת התאמה למערכת על לחץ בחדרי מדרגות`;

  ngOnInit(): void {
    super.ngOnInit();
    this.systemDescription =
      this.inspection?.inspectionPressureSystemInStairwellsCompatibilityCheck
        ?.stairsRooms[0]?.type === PressureSystemType.Stairway
        ? `בדיקת התאמה למערכת על לחץ בחדרי מדרגות`
        : `בדיקת התאמה למערכת על לחץ בפרוזדור מילוט מוגן מעל 50 מטר`;
  }
}
